module.exports = __webpack_public_path__ + "static/media/experience.065b288e.png";